import { DraftPreview } from '../../DraftPreview';
import { useComposerData } from '../ComposerDataProvider';
import { ComposerSelect } from '../ComposerSelect';
export function Root() {
    const { selectedComposerId, closeDialog, goBackToSelect, initialParentId } = useComposerData();
    if (selectedComposerId) {
        return (<DraftPreview composerId={selectedComposerId} initialParentId={initialParentId} onClose={closeDialog} onGoBack={goBackToSelect}/>);
    }
    return <ComposerSelect />;
}
